import { StakeholdersDataType } from '@commenda/types/src/cap-table/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useStakeholders(corporationId: number, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: StakeholdersDataType[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `capTable/stakeholder/byCorporationId/${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
